/***
 * @file:
 * @author: caojianping
 * @Date: 2021-03-08 09:38:18
 */
import { Component, Input, OnInit } from '@angular/core';
import { SettingsService } from '@ithinkdt/shared/browser';
import { isEmpty } from 'lodash';

import { ChangeAccountService } from '@ithinkdt/theme/fetch-service';
import { IMenuOption, ISystemMenuOption, MENUS } from '../pcp-theme.config';
@Component({
  selector: 'dt-pcp-theme-menu',
  templateUrl: './pcp-theme-menu.component.html',
  styleUrls: ['./pcp-theme-menu.component.scss'],
})
export class PcpThemeMenuComponent implements OnInit {
  menus: IMenuOption[] = []; // èååè¡¨
  isSystemMenu = false; // æ¯å¦ä¸ºç³»ç»èå
  validMenuList: IMenuOption[] = [];
  todoAccount: number; // todoçå¾åæ°é
  @Input() isCollapsed: boolean;

  constructor(private settingSrv: SettingsService, private changeAccountSrv: ChangeAccountService) {}

  ngOnInit() {
    const validMenuList: IMenuOption[] = [];
    if (!isEmpty(this.settingSrv.menu)) {
      this.getValidMenu(this.settingSrv.menu, validMenuList);
    }
    this.menus = [...validMenuList];
    this.getTodoAccount();
    // this.menus = [...MENUS, ...validMenuList];
  }
  getTodoAccount() {
    const parmas = {
      taskType: true,
      keyWord: '',
      formParam: {
        pageSize: 10,
        pageNumber: 1,
      },
    };
    this.changeAccountSrv.querTaskAccount(parmas).subscribe((res) => {
      const data = res.record || 0;
      this.todoAccount = data;
    });
  }
  // è·åç³»ç»èååè¡¨
  getSystemMenus(data: any[] = []): IMenuOption[] {
    const systemMenus: IMenuOption[] = [];
    (data || []).forEach((item: any) => {
      const { action, moduleName, icon, children } = item;
      if (action && moduleName) {
        systemMenus.push({
          router: action,
          title: moduleName, // TODO æ ¹æ®å½åè¯­è¨åæ¢
          icon,
          children,
        });
      }
      if (item.hasChildren) {
        systemMenus.push(...this.getSystemMenus(children));
      }
    });
    return systemMenus;
  }

  // è·åç³»ç»èååè¡¨
  getValidMenu(menuTree = [], parent: IMenuOption[] = []) {
    menuTree.forEach((m) => {
      const { action, moduleName, icon, children } = m;
      const self = {
        router: action,
        title: moduleName, // TODO æ ¹æ®å½åè¯­è¨åæ¢
        icon,
        children: [],
      };
      parent.push(self);
      if (m.hasChildren) {
        this.getValidMenu(children, self.children);
      }
    });
  }

  // å³é­ç³»ç»èå
  closeSystemMenu() {
    this.isSystemMenu = false;
  }
}
